import React, { memo, type FC } from 'react';
import Button from '../Button/ButtonV2';
import { cn } from '../../utils/ui';

export interface EditControlsProps {
    className?: string;
    isSaving?: boolean;
    isSaveDisabled?: boolean;
    onSave: () => void;
    onCancel: () => void;
}

// Add this component near your other imports
const EditControls: FC<EditControlsProps> = props => {
    const { onSave, onCancel, className = '' } = props;

    function renderSaveButton() {
        const { isSaving, isSaveDisabled } = props;
        return (
            <Button isDisabled={isSaveDisabled} isLoading={isSaving} size="xs" variant="filled" onClick={onSave}>
                Save
            </Button>
        );
    }

    function renderCancelButton() {
        return (
            <Button size="xs" variant="ghost" onClick={onCancel}>
                Cancel
            </Button>
        );
    }

    return (
        <div className={cn('flex items-center space-x-3', className)}>
            {renderCancelButton()}
            {renderSaveButton()}
        </div>
    );
};

export default memo(EditControls);
